import { Component, Injectable } from '@angular/core';
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../../globals/Globals';

@Injectable()
export class WsService {
  socket;
  socketSubject = new Subject();
  stompClient;
  private wsURL = Globals.SERVER_ADDR + '/ws/connect';

  constructor() {
    const ws = new SockJS(this.wsURL);
    this.stompClient = Stomp.over(ws);

    const that = this;
    this.stompClient.connect({}, function(frame) {
      that.stompClient.subscribe('/ws/notify', message => {
        that.socketSubject.next(JSON.parse(message.body));
      });
    });
  }

  getSocketSubscriber(): Observable<Object> {
    return this.socketSubject.asObservable();
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/services/websocket/WsService.ts